// extracted by mini-css-extract-plugin
module.exports = {"card":"_17WfNLXlK85GJsX-EeyrmV","date":"OG3hoby57F6FffeAf2Igm"};